import React, { useMemo } from 'react';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import TeamMember from './TeamMember';
import { IMember } from './TeamDialog';
import { setMembers as setMembersAction } from '../../store/actions/onlineDesignerAction';
import { useDispatch } from 'react-redux';
import {useTranslation} from "react-i18next";

interface Props {}

const TeamList: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const { data: productData } = useTypedSelector(
        (state) => state.od.loadProduct
    );

    const { data: teamData } = useTypedSelector((state) => state.od.team);

    const handleChangeMember = (index: number, member: IMember) => {
        if (teamData) {
            const newMembers = [...teamData];
            newMembers[index] = member;
            dispatch(setMembersAction(newMembers));
        }
    };

    const handleRemoveMember = (key: number) => {
        if (teamData) {
            const newMembers = [...teamData];
            newMembers.splice(key, 1);
            dispatch(setMembersAction(newMembers));
        }
    };

    const handleAddMember = () => {
        if (teamData) {
            const newMembers = [...teamData];

            newMembers.push({
                name: '',
                number: '',
                size: null,
                id: Math.random() * 1000,
            });
            dispatch(setMembersAction(newMembers));
        }
    };

    const teamDataDisplay = useMemo<IMember[]>((): IMember[] => {
        if (teamData === null || teamData.length === 0) {
            return [
                {
                    name: '',
                    number: '',
                    size: null,
                    id: Math.random() * 1000,
                },
            ];
        }
        return [
            ...teamData,
            {
                name: '',
                number: '',
                size: null,
                id: Math.random() * 1000,
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teamData]);

    return (
        <React.Fragment>
            {productData && (
                <React.Fragment>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('Player name')}</TableCell>
                                    <TableCell>{t('Player number')}</TableCell>
                                    <TableCell>{t('Size')}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {teamDataDisplay &&
                                    teamDataDisplay.map((member, index) => (
                                        <TeamMember
                                            key={member.id}
                                            member={member}
                                            index={index}
                                            last={
                                                index ===
                                                teamDataDisplay.length - 1
                                            }
                                            onChange={handleChangeMember}
                                            onRemove={() =>
                                                handleRemoveMember(index)
                                            }
                                        />
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <AddCircleOutline onClick={handleAddMember} />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default TeamList;
